import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaShoppingCart, FaBars, FaTimes } from "react-icons/fa";
import { useCart } from "../context/CartContext";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { cartItems } = useCart();

  return (
    <>
      <nav style={styles.nav}>
        <div className="container" style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
          {/* Logo */}
          <div style={styles.logo}>
            <img
              src="https://res.cloudinary.com/defcamc5x/image/upload/v1762089600/ybyvejhuq3t6qm2ggqlv.png"
              alt="L’artisan Logo"
              style={styles.logoImg}
            />
          </div>

          {/* Links */}
          <ul style={styles.links}>
            <li><Link to="/" style={styles.link}>Home</Link></li>
            <li><Link to="/shop" style={styles.link}>Shop</Link></li>
            <li><Link to="/about" style={styles.link}>About</Link></li>
            <li><Link to="/contact" style={styles.link}>Contact</Link></li>
          </ul>

          {/* Icons */}
          <div style={styles.icons}>
            <Link to="/cart" style={styles.cart}>
              <FaShoppingCart />
              {cartItems.length > 0 && (
                <span style={styles.badge}>{cartItems.length}</span>
              )}
            </Link>
            <button style={styles.menuBtn} onClick={() => setIsOpen(true)}>
              <FaBars />
            </button>
          </div>
        </div>
      </nav>

      {/* Sidebar Menu */}
      {isOpen && (
        <div style={styles.sidebar}>
          <button style={styles.closeBtn} onClick={() => setIsOpen(false)}>
            <FaTimes />
          </button>
          <ul style={styles.sidebarLinks}>
            <li><Link to="/" style={styles.sidebarLink} onClick={() => setIsOpen(false)}>Home</Link></li>
            <li><Link to="/shop" style={styles.sidebarLink} onClick={() => setIsOpen(false)}>Shop</Link></li>
            <li><Link to="/about" style={styles.sidebarLink} onClick={() => setIsOpen(false)}>About</Link></li>
            <li><Link to="/contact" style={styles.sidebarLink} onClick={() => setIsOpen(false)}>Contact</Link></li>
          </ul>
        </div>
      )}
    </>
  );
};

const styles = {
  nav: {
    position: "sticky",
    top: 0,
    zIndex: 1000,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 30px",
    background: "#fff",
    color: "#5b3a29",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  },
  logoImg: {
    width: "90px",
  },
  links: {
    display: "flex",
    listStyle: "none",
    gap: "25px",
    margin: 0,
  },
  link: {
    color: "#5b3a29",
    textDecoration: "none",
    fontWeight: "500",
    fontSize: "20px",
    transition: "color 0.3s",
  },
  icons: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    position: "relative",
  },
  cart: {
    color: "#5b3a29",
    fontSize: "30px",
    textDecoration: "none",
    position: "relative",
  },
  badge: {
    position: "absolute",
    top: "-8px",
    right: "-8px",
    background: "#d4af37",
    color: "#fff",
    borderRadius: "50%",
    padding: "2px 6px",
    fontSize: "12px",
    fontWeight: "bold",
  },
  menuBtn: {
    display: "none",
    background: "none",
    border: "none",
    fontSize: "22px",
    color: "#5b3a29",
    cursor: "pointer",
  },
  sidebar: {
    position: "fixed",
    top: 0,
    right: 0,
    width: "70%",
    height: "100%",
    background: "#5b3a29",
    color: "#fff",
    padding: "30px",
    zIndex: 2000,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    animation: "slideIn 0.3s ease-in-out",
  },
  closeBtn: {
    background: "none",
    border: "none",
    color: "#fff",
    fontSize: "26px",
    alignSelf: "flex-end",
    cursor: "pointer",
  },
  sidebarLinks: {
    listStyle: "none",
    padding: 0,
    marginTop: "40px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  sidebarLink: {
    color: "#fff",
    textDecoration: "none",
    fontSize: "18px",
    fontWeight: "500",
  },
};

// Responsive style injection
const sheet = document.createElement("style");
sheet.innerHTML = `
@media (max-width: 768px) {
  ul {
    display: none !important;
  }
  button[style*="menuBtn"] {
    display: block !important;
  }
}
@keyframes slideIn {
  from { right: -100%; }
  to { right: 0; }
}
`;
document.head.appendChild(sheet);

export default Navbar;
